import script from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=154caba4&lang=scss"

const __exports__ = script;

export default __exports__